import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import api from "../../seller-apis/api";
import "../../assets/css/monthlyReport.css";
import MainLoader from "../common/Loader/PageLoader";
const MonthlyReport = () => {
  var outerdiv;
  var loaderDiv;

  const [data, setData] = useState([]);
  const [date, setDate] = useState();
  const [showDate, setShowDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  // Loader
  const [ennewloader, setennewloader] = useState("block");

  useEffect(() => {
    let myVariable = new Date();
    let makeDate = new Date(myVariable);
    let lastMonthDate;
    if (makeDate.getMonth() === 0) {
      lastMonthDate = makeDate.getFullYear() - 1 + "-" + 12;
    } else if (makeDate.getMonth() < 10) {
      lastMonthDate = makeDate.getFullYear() + "-" + "0" + makeDate.getMonth();
    } else {
      lastMonthDate = makeDate.getFullYear() + "-" + makeDate.getMonth();
    }
    applyLoader();
    let arr = [];
    arr = new Date(lastMonthDate).toString().split(" ", 4);
    setDate(lastMonthDate);
    setMaxDate(lastMonthDate);
    setShowDate(arr[1] + "," + arr[3]);
    let d = lastday(makeDate.getFullYear(), makeDate.getMonth());
    setStartMonth(lastMonthDate + "-01T00:00:00");
    setEndMonth(lastMonthDate + "-" + d + "T23:59:59");
    api.vendorledger
      .getVendorsForMonthlyReport({
        filter: {
          "from-deliveryDate": lastMonthDate + "-01T00:00:00",
          "to-deliveryDate": lastMonthDate + "-" + d + "T23:59:59",
          "products.vendorDetails._id": localStorage.getItem("userId"),
        },
        excludeField: {},
        pageNo: 1,
        size: 10,
        sortFilter: {
          _id: 1,
        },
      })
      .then((res) => {
        setData(res.data);
        removeLoader();
      })
      .catch((err) => console.log(err));
  }, []);

  function handleDateChange(e) {
    if (e === "") {
      setDate("");
      setShowDate("");
      setData("");
    } else {
      applyLoader();
      let arr = [];
      let dArr = [];
      arr = e.split("-");
      let d = lastday(arr[0], arr[1]);
      setDate(e);
      dArr = new Date(e).toString().split(" ", 4);
      setShowDate(dArr[1] + "," + dArr[3]);
      setStartMonth(e + "-01T00:00:00");
      setEndMonth(e + "-" + d + "T23:59:59");
      api.vendorledger
        .getVendorsForMonthlyReport({
          filter: {
            "from-deliveryDate": e + "-01T00:00:00",
            "to-deliveryDate": e + "-" + d + "T23:59:59",
            "products.vendorDetails._id": localStorage.getItem("userId"),
          },
          excludeField: {},
          pageNo: 1,
          size: 10,
          sortFilter: {
            _id: 1,
          },
        })
        .then((res) => {
          setData(res.data);
          removeLoader();
        })
        .catch((err) => console.log(err));
    }
  }

  // Get last day of month
  var lastday = function (y, m) {
    return new Date(y, m, 0).getDate();
  };

  // handle annexure download
  function handleReportDwnld() {
    api.vendorledger
      .monthlyReportDataExp({
        filter: {
          "vendorDetails._id": localStorage.getItem("userId"),
          "from-deliveryDate": startMonth,
          "to-deliveryDate": endMonth,
        },
      })
      .then((res) => {
        let url = window.URL.createObjectURL(res.data);
        let link = document.createElement("a");
        link.setAttribute("download", "Annexure_" + showDate);
        link.href = url;
        link.click();
      })
      .catch((err) => console.log(err));
  }

  // apply loaders

  function applyLoader() {
    outerdiv = document.getElementById("payment_tab");
    loaderDiv = document.getElementById("enNewLoader");
    loaderDiv.classList.add("loader-bt");
    setennewloader("flex");
    outerdiv.classList.add("div-bk");
  }

  // remove loader

  function removeLoader() {
    loaderDiv.classList.remove("loader-bt");
    setennewloader("none");
    outerdiv.classList.remove("div-bk");
  }

  // l1-2977
  const downloadFile = (file, docNo, type) => {
    let lastDot = file.lastIndexOf(".");
    let fileType = file.substr(lastDot);
    let downloadName = docNo + "-" + type;
    let data = {
      "bucket": "seller_doc",
      "key": file
    }
    api.docs.getImage(data).then((res) => {
      const fileUrl = res.data;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", downloadName + fileType);
      document.body.appendChild(link);
      link.target = "_blank";
      link.click();
      document.body.removeChild(link);
    }).catch(err => console.log(err))
  }
 

  return (
    <div id="orDeskContain" className="mb-4 mx-2">
      {/* New orders desktop */}
      <div className="tab">
        <div className="contain_payment_table mx-2">
          <div className="d-flex mb-3 justify-content-end">
            <div className="theme-shed1 p-2">
              <div className="m-auto mt-1">
                <span className="payment_dates">
                  Select Month: -{" "}
                  <input
                    type="month"
                    value={date}
                    onChange={(e) => handleDateChange(e.target.value)}
                    min="2022-09"
                    max={maxDate}
                  ></input>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
        <table
          className="payment_table"
          style={{ width: "100%" }}
          id="payment_tab"
        >
          <thead>
            <tr className="monthly_report_tr">
              <th className="thead_title " style={{ width: "30%" }}>
                For the Month of
              </th>

              <th className="thead_title" style={{ width: "30%" }}>
                Bill Type
              </th>

              <th className="thead_title" style={{ width: "30%" }}>
                Status
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="monthly_report_tr">
              <td>{showDate == undefined ? <></> : showDate}</td>
              <td>Commission Invoice</td>
              <td>
                {data &&
                  data.map((item, index) => {
                    if (item.invoiceUploaded) {
                      return (
                        <>
                          Download Report{" "}
                          <span>
                            {item.commissionInvoice ? (
                              <span
                                onClick={() => downloadFile(item.commissionInvoice, "Commission_Invoice_" + showDate, "pdf")}
                              >
                                <i
                                  className="fa fa-download"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            ) : (
                              <></>
                            )}
                          </span>
                        </>
                      );
                    } else {
                      return <>Report not generated</>;
                    }
                  })}
              </td>
            </tr>
            <tr className="monthly_report_tr">
              <td>{showDate == undefined ? <></> : showDate}</td>
              <td>Annexure</td>
              <td>
                {/*  */}
                {data &&
                  data.map((item, index) => {
                    if (item.reportGenerated) {
                      return (
                        <>
                          Download Report{" "}
                          <span
                              onClick={()=> handleReportDwnld(item.reportGenerated, "Annexure_" + showDate, "pdf")}>
                              <i
                                className="fa fa-download"
                                aria-hidden="true"
                              ></i>
                          </span>
                        </>
                      );
                    } else {
                      return <>Report not generated</>;
                    }
                  })}
              </td>
            </tr>
            <tr className="monthly_report_tr">
              <td>{showDate == undefined ? <></> : showDate}</td>
              <td>Courier Bill</td>
              <td>
                {data &&
                  data.map((item, index) => {
                    if (item.courierBill) {
                      return (
                        <>
                          Download Report{" "}
                          <span
                              onClick={()=> downloadFile(item.courierBill, "Courier_Bill_" + showDate, "pdf")}
                            >
                              <i
                                className="fa fa-download"
                                aria-hidden="true"
                              ></i>
                          </span>
                        </>
                      );
                    } else {
                      return <>Report not generated</>;
                    }
                  })}
              </td>
            </tr>
            <tr className="monthly_report_tr">
              <td>{showDate == undefined ? <></> : showDate}</td>
              <td>Credit Note</td>
              <td>
                {data &&
                  data.map((item, index) => {
                    if (item.creditNote) {
                      return (
                        <>
                          Download Report{" "}
                          <span
                              onClick={()=> downloadFile(item.creditNote, "Credit_Note_" + showDate, "pdf")}
                            >
                              <i
                                className="fa fa-download"
                                aria-hidden="true"
                              ></i>
                          </span>
                        </>
                      );
                    } else {
                      return <>Report not generated</>;
                    }
                  })}
              </td>
            </tr>
            <tr className="monthly_report_tr">
              <td>{showDate == undefined ? <></> : showDate}</td>
              <td>Other Invoices</td>
              <td>
                {data &&
                  data.map((item, index) => {
                    if (item?.delayDispatchInvoice) {
                      return (
                        <>
                          Download Report{" "}
                          <span
                              onClick={()=> downloadFile(item.delayDispatchInvoice, "Delay_Dispatch_Invoice_" + showDate, "pdf")}
                            >
                              <i
                                className="fa fa-download"
                                aria-hidden="true"
                              ></i>
                          </span>
                        </>
                      );
                    } else {
                      return <>Report not generated</>;
                    }
                  })}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>

      <div className="d-flex justify-content-center" id="enNewLoader">
        <div
          style={{ display: ennewloader }}
        >
         <MainLoader/>
        </div>
      </div>
    </div>
  );
};

export default MonthlyReport;
